<ng-container
  *ngIf="
    (isSuperAdminRoute$ | async) === false &&
    (isAutomationsRoute$ | async) === false &&
    (trialDetails$ | async) as trialDetails
  "
>
  <glxy-alert
    *ngIf="trialDetails?.onTrial"
    type="info"
    [borderRadius]="false"
    [showAction]="true"
    [actionTitle]="'TRIAL_BANNER.ACTION_BUTTON' | translate"
    (actionClick)="openSalesVideo()"
  >
    <strong>{{ trialDetails.tierName | translate }}{{ 'TRIAL_BANNER.PLAN' | translate }}</strong>
    <ng-container *ngIf="{ remainingDays: remainingDays$ | async } as data">
      <span class="days-remaining" *ngIf="data.remainingDays === 0">
        {{ 'TRIAL_BANNER.ENDS_TODAY' | translate }}
      </span>
      <ng-container *ngIf="data.remainingDays > 0">
        <span>
          {{ 'TRIAL_BANNER.DESCRIPTION' | translate: { date: trialDetails.endDate | glxyDate: dateFormat.longDate } }}
        </span>
        <span class="days-remaining" [ngPlural]="data.remainingDays">
          <ng-template ngPluralCase="=1">
            {{ 'TRIAL_BANNER.DAY_REMAINING' | translate }}
          </ng-template>
          <ng-template ngPluralCase="other">
            {{ 'TRIAL_BANNER.DAYS_REMAINING' | translate: { days: data.remainingDays } }}
          </ng-template>
        </span>
      </ng-container>
    </ng-container>
    <span class="learn-more" (click)="learnMore()">
      {{ 'TRIAL_BANNER.LEARN_MORE' | translate }}
    </span>
  </glxy-alert>
</ng-container>
